<template>
  <div
    :class="
      mqShallShowRightSidebar
        ? 'sidebar-right active'
        : 'sidebar-right in-active'
    "
  >
    <!--  <div class="sidebar-right">-->

    <!-- Sidebar Content -->
    <div
      class="sidebar-content right-sidebar-content"
      :class="{
        show: mqShallShowRightSidebar,
        'zero-width': !mqShallShowRightSidebar,
      }"
    >
      <div class="tab-container">
        <b-tabs content-class="mt-0">
          <b-tab :title="$t('general.profile')" active>
            <!-- {{ activeChannel }} -->
            <div class="tree-node accordion" role="tablist">
              <b-card no-body class="mb-0">
                <b-card-header header-tag="header" variant="info">
                  <div class="personal-info pt-0" style="width: 100%">
                    <div class="list-unstyled mb-2">
                      <!--Visitor Section-->
                      <h6 class="section-label mb-2">
                        {{ $t("ticket.visitor_info") }}
                      </h6>
                      <div style="display: grid; gap: 1em">
                        <EditableLabel
                          icon="UserIcon"
                          :placeholder="$t('ticket.enter_name')"
                          :editable="true"
                          type-data="name"
                          :active-channel="activeChannel"
                          :meta-data="visitorInformation.id"
                          :default-data="visitorInformation.name"
                          validate-data="text"
                        />

                        <EditableLabel
                          icon="MailIcon"
                          :placeholder="$t('ticket.enter_email')"
                          :editable="true"
                          type-data="email"
                          :active-channel="activeChannel"
                          :meta-data="visitorInformation.id"
                          :default-data="visitorInformation.email"
                          validate-data="email"
                          @update="
                            (res) => (visitorInformation.email = res.email)
                          "
                        />

                        <EditableLabel
                          icon="PhoneIcon"
                          :placeholder="$t('ticket.enter_phone_number')"
                          :editable="true"
                          type-data="phone"
                          :active-channel="activeChannel"
                          :meta-data="visitorInformation.id"
                          :default-data="visitorInformation.phone"
                          validate-data="number"
                        />

                        <EditableLabel
                          icon="MapPinIcon"
                          placeholder="Enter Name"
                          :default-data="data.origin"
                        />

                        <EditableLabel
                          icon="MonitorIcon"
                          placeholder="Enter Name"
                          :default-data="visitorInformation.device"
                        />

                        <EditableLabel
                          icon="StopCircleIcon"
                          placeholder="Enter Name"
                          :default-data="visitorInformation.ipAddress"
                        />

                        <EditableLabel
                          icon="AlertCircleIcon"
                          :default-data="visitorInformation.meta"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="personal-info pt-0" style="width: 100%">
                    <div class="list-unstyled mb-2">
                      <!--Visitor Section-->
                      <h6 class="section-label mb-2">
                        {{ $t("chat.assign") }}
                      </h6>
                      <div style="display: grid; gap: 1em">
                        <EditableLabel
                          icon="UserIcon"
                          :placeholder="$t('ticket.enter_name')"
                          :editable="true"
                          type-data="name"
                          :active-channel="activeChannel"
                          :meta-data="merchantUser.id"
                          :default-data="
                            merchantUser.firstName + ' ' + merchantUser.lastName
                          "
                          validate-data="text"
                        />

                        <EditableLabel
                          icon="MailIcon"
                          :placeholder="$t('ticket.enter_email')"
                          :editable="true"
                          type-data="email"
                          :active-channel="activeChannel"
                          :meta-data="merchantUser.id"
                          :default-data="merchantUser.email"
                          validate-data="email"
                          @update="(res) => (merchantUser.email = res.email)"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- <TicketHistory
                    class="w-100"
                    :customer-id="visitorInformation.id"
                    :email="visitorInformation.email || ''"
                    :history="visitorTicketHistory"
                    :loading="ticketStore.loading.isSubmitting"
                    :options="ticketStore.getOptions"
                    @submit-respond="handleSubmitRespond"
                    @submit="
                      (createForm) =>
                        ticketStore.createTicketAsync(
                          createForm,
                          ticketStore.getSelectedTicketDetailCustomerID
                        )
                    "
                  /> -->
                </b-card-header>
              </b-card>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { BCardHeader, BCard, BTab, BTabs } from "bootstrap-vue";
import Repository from "@/repositories/RepositoryFactory";
import TicketRepository from "@/repositories/Api/TicketRepository";
import EditableLabel from "@/components/global-components/EditableLabelChatPage.vue";
import useTicketStore from "@/store-pinia/useTicketStore";
import TicketHistory from "@/views/ticket/ticketRightSidebar/ticketHistory.vue";
import { onMounted } from "@vue/composition-api";
import Toast from "@/libs/toast";
import useJwt from "@/auth/jwt/useJwt";

const QuickMessageRepository = Repository.get("quickMessage");

export default {
  name: "RightSidebar",
  components: {
    TicketHistory,
    EditableLabel,
    // BSV
    BTab,
    BTabs,

    BCardHeader,
    BCard,
  },

  props: {
    sendTextMessage: {
      type: Function,
      require: true,
      default: () => {},
    },
    mqShallShowRightSidebar: {
      type: Boolean,
      required: true,
    },
    connectionStatus: {
      type: Boolean,
      default: true,
    },
    channels: {
      type: Array,
      default: () => [],
    },
    activeChannel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      data: JSON.parse(
        localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
      ),
      tabIndex: 0,
      visible: true,
      visiblePersonal: true,
      loading: false,
      isShowSearch: true,
      items: [],
      originItems: [],
      filterOptions: [
        {
          value: "public",
          textTeam: this.$t("button.team"),
        },
        {
          value: "private",
          textPersonal: this.$t("button.personal"),
        },
      ],
      tabOptions: [
        {
          value: "public",
          text: "QuickMessage",
        },
        {
          value: "private",
          text: "profile",
        },
      ],
      query: {
        filter: "public",
        search: "",
      },
      selected: null,
      visitorInformation: {},
      visitorTicketHistory: [],
      merchantUser: {},
    };
  },

  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
    statusLabel() {
      // Status Label
      //   OPEN: 1,
      //   RESOLVED: 2,
      //   PENDING: 3,
      switch (this.activeChannel.state) {
        case "1":
          return this.$t("ticket.open");
        case "2":
          return this.$t("ticket.resolved");
        case "3":
          return this.$t("ticket.pending");
        default:
          return "Unknown";
      }
    },
  },
  watch: {
    activeChannel: {
      handler(newValue) {
        this.getVisitorInformation();
      },
      deep: true,
    },
    mqShallShowRightSidebar(value) {
      if (value) {
        this.list();
      }
    },
  },

  created() {},

  methods: {
    makeSuccessToast(append = false) {
      Toast.fire({
        icon: "success",
        title: this.$t("ticket.create_ticket_successfully_message"),
      });
    },
    makeFailToast(append = false) {
      Toast.fire({
        icon: "error",
        title: this.$t("ticket.create_ticket_failed_message"),
      });
    },
    async handleSubmitRespond(response) {
      if (response) {
        this.makeSuccessToast(true);
        this.getVisitorTicketHistory(this.activeChannel.customer.id);
      } else {
        this.makeFailToast(true);
      }
    },

    getVisitorInformation() {
      this.visitorInformation = this.activeChannel.customer;
      this.merchantUser = this.activeChannel.merchantUser;
    },
    getVisitorTicketHistory(visitorId) {
      TicketRepository.getTicketsHistory(visitorId)
        .then((res) => {
          const { list } = res.data.data;
          // console.log(list)
          this.visitorTicketHistory = list;
        })
        .catch((e) => {
          // console.log(e)
        });
    },
    list() {
      if (this.originItems.length > 0) return;
      this.loading = true;
      QuickMessageRepository.show()

        .then((response) => {
          this.originItems = response.data;
          this.$nextTick(() => {
            this.changeFilter();
          });
        })
        .catch()
        .then(() => {
          this.loading = false;
        });
    },
    buildTree(list, deleteNoChildren = true) {
      const map = {};
      let node;
      let roots = [];
      let i;

      for (i = 0; i < list.length; i += 1) {
        list[i] = { ...list[i] };
        map[list[i].id] = i;
        list[i].parentId = list[i].parent;
        list[i].children = [];
      }

      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.visible) {
          if (node.parent && list[map[node.parent]]) {
            list[map[node.parent]].children.push(node);
          } else {
            roots.push(node);
          }
        }
      }

      if (deleteNoChildren) {
        roots = roots.filter((e) => e.children.length > 0 || e.parentId);
      }

      return roots;
    },
    changeFilter(filter = null) {
      if (filter) {
        this.query.filter = filter;
      }
      const filterItems = this.originItems
        .map((e) => ({ ...e }))
        .filter(
          (e) =>
            e.accessSpecifier == this.query.filter &&
            (!this.query.search.trim() ||
              e.title.toLowerCase().includes(this.query.search.toLowerCase()) ||
              e.description
                ?.toLowerCase()
                .includes(this.query.search.toLowerCase()))
        );
      this.items = this.buildTree(filterItems);
    },
    searching() {
      this.isShowSearch = !this.isShowSearch;
      if (!this.isShowSearch && this.query.search) {
        this.query.search = "";
        this.search();
      }
    },
    search() {
      this.changeFilter();
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      }
      return ["bg-light", "text-info"];
    },
    editCustomerName() {},
    updateCustomerName() {},
    getTicketHistoryForCustomer() {
      TicketRepository.GetTicketHistory(this.activeChannel.customer?.id)

        .then((response) => {
          // console.log('history', response.data.data)
        })
        .catch((error) => {
          // console.log(error)
        });
    },
  },
  setup() {
    const ticketStore = useTicketStore();

    onMounted(() => {
      ticketStore.getCreateTicketOptionAsync();
    });

    return { ticketStore };
  },
};
</script>

<style lang="scss" scoped>
.active {
  //padding-right: 8em;
}
.in-active {
  //padding-right: 0;
}
.sidebar-right {
  //overflow-y: scroll;
  //overflow-x: hidden;

  .sidebar-content {
    border-right: 0;
    border-left: 1px solid #ebe9f1;
    height: 100%;
    overflow: auto;

    &.right-sidebar-content {
      transition: all 0.2s linear;
      display: block;
      //padding-right: 8em;

      &.zero-width {
        width: 0px !important;
        //padding-right:0
      }
    }
  }
}

.card .card-header {
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: revert;
  // margin-top:10px;
}

[dir] .card-body {
  padding: 1.5rem;
  padding-top: 0rem !important;
}

[dir] .accordion > .card > .card-header {
  border-radius: 0;
  // margin-bottom: -18px;
}

[dir] .nav-tabs {
  padding-left: 0.75em;
  padding-right: 0.75em;
  margin-bottom: 0;
  padding-top: 0.75em;
}
</style>
